import { computed, onMounted } from "vue";
import { useReservationStore } from "../stores";
import { reservationService } from "../services";
import { defaultReservationFilters } from "../models";
// =============================================================================
// COMPOSABLE
// =============================================================================
export function useReservations(options = {}) {
    const store = useReservationStore();
    // ---------------------------------------------------------------------------
    // COMPUTED
    // ---------------------------------------------------------------------------
    const items = computed(() => store.items);
    const activeFilters = computed(() => store.activeFilters);
    const hasMore = computed(() => store.hasMore);
    const isLoading = computed(() => store.isLoading);
    const isLoadingMore = computed(() => store.isLoadingMore);
    const error = computed(() => store.error);
    // ---------------------------------------------------------------------------
    // FILTER SETTERS (each resets to page 1 with the merged filters)
    // ---------------------------------------------------------------------------
    async function fetchWithFilters(patch) {
        try {
            await store.fetchFirstPage({ ...store.activeFilters, ...patch });
        }
        catch (err) {
            options.onError?.(err);
        }
    }
    async function applyTab(tabId) {
        const { reservationStatus, fulfillmentStatus } = reservationService.getTabFilters(tabId);
        await fetchWithFilters({ reservationStatus, fulfillmentStatus });
    }
    async function setSource(source) {
        await fetchWithFilters({ source });
    }
    async function setReservationStatus(status) {
        await fetchWithFilters({ reservationStatus: status });
    }
    async function setFulfillmentStatus(status) {
        await fetchWithFilters({ fulfillmentStatus: status });
    }
    async function setService(id) {
        await fetchWithFilters({ serviceId: id });
    }
    async function clearFilters() {
        try {
            await store.fetchFirstPage({ ...defaultReservationFilters });
        }
        catch (err) {
            options.onError?.(err);
        }
    }
    // ---------------------------------------------------------------------------
    // DATA LOADING
    // ---------------------------------------------------------------------------
    async function loadMore() {
        try {
            await store.loadMore();
        }
        catch (err) {
            options.onError?.(err);
        }
    }
    async function load() {
        try {
            await store.fetchFirstPage(store.activeFilters);
        }
        catch (err) {
            options.onError?.(err);
        }
    }
    if (options.autoLoad !== false) {
        onMounted(() => load());
    }
    // ---------------------------------------------------------------------------
    // RETURN
    // ---------------------------------------------------------------------------
    return {
        items,
        activeFilters,
        hasMore,
        isLoading,
        isLoadingMore,
        error,
        applyTab,
        setSource,
        setReservationStatus,
        setFulfillmentStatus,
        setService,
        clearFilters,
        loadMore,
        load,
    };
}
